module.exports = __webpack_public_path__ + "img/HA2502-107.5fff6774.jpg";